var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"align-v":"center","align-h":"center"}},[_c('b-col',{attrs:{"md":"10"}},[_c('vue-good-table',{attrs:{"columns":this.$store.getters.getColumns,"rows":_vm.rows,"styleClass":"vgt-responsive","lineNumbers":true,"search-options":{ enabled: true, placeholder: 'Find..' },"pagination-options":{ enabled: true,  position: 'bottom' },"selectOptions":{
            enabled: false,
            selectOnCheckboxOnly: false,
            selectionInfoClass: 'alert alert-info m-b-0 no-rounded-corner',
            selectionText: '',
            clearSelectionText: 'Clear selected..',
			  }}}),_vm._v(" "),_c('b-button',{staticClass:"setParametersButton",attrs:{"variant":"info"},on:{"click":_vm.setParameters}},[_vm._v("Change attribute name")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cdce692","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OriginalData/OriginalDataTable.vue
// module id = null
// module chunks = 